import { render } from "./PageLayoutMaintenance.vue?vue&type=template&id=86437dc6"
import script from "./PageLayoutMaintenance.vue?vue&type=script&lang=js"
export * from "./PageLayoutMaintenance.vue?vue&type=script&lang=js"

import "./PageLayoutMaintenance.vue?vue&type=style&index=0&id=86437dc6&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__